export default "__VITE_ASSET__B$Tci8Qy__"